module.exports = __webpack_public_path__ + "static/media/remove_circle_outline_black_24dp 8.d839cd75.svg";